import { render } from "./UiPlatform.vue?vue&type=template&id=8e0f7f48"
import script from "./UiPlatform.vue?vue&type=script&lang=js"
export * from "./UiPlatform.vue?vue&type=script&lang=js"

import "./UiPlatform.vue?vue&type=style&index=0&id=8e0f7f48&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__